import $ from 'jquery'
import debounce from '../utils/debounce'
import { breakpoint } from '../../project-variables.json'

const navigation = document.querySelector('#nav-main')
const button = document.querySelector('.js-menu-toggle')
var   offset = 0;

button.addEventListener('click', toggleNavi, false)

function toggleNavi () {
  const open = navigation.getAttribute('aria-hidden') === 'false'
  open ? hideNavi() : showNavi()
}

function showNavi () {
  offset = window.pageYOffset || document.documentElement.scrollTop
  navigation.style.display = 'block'
  setTimeout(() => navigation.setAttribute('aria-hidden', 'false'))
  document.body.classList.add('nav-open')
}

function hideNavi (timeout = 100) {
  setTimeout(() => (navigation.style.display = 'none'), timeout)
  navigation.setAttribute('aria-hidden', 'true')
  document.body.classList.remove('nav-open')
}

window.addEventListener('scroll', debounce(toggleNaviToggle), false)
window.addEventListener('resize', debounce(toggleNaviToggle), false)
toggleNaviToggle()

function toggleNaviToggle () {
  const scrolled = window.pageYOffset || document.documentElement.scrollTop

  if (offset != scrolled) {
    const mq = window.matchMedia(`(min-width: ${breakpoint.md}px)`).matches
    document.body.classList.remove('nav-toggle')
    hideNavi()
  } else {
    document.body.classList.add('nav-toggle')
  }
}

$('#nav-main').on('click', 'a', scrollToElement)

function scrollToElement (e) {
  const id = this.hash.replace(/^#?/, '')
  const el = document.getElementById(id)

  if (el) {
    e.preventDefault()
    hideNavi()
    $('html,body').animate({ scrollTop: el.offsetTop }, 1000, 'swing', () => {
      window.location.hash = id
    })
  }
}

$('a.menu-toggle').on('click', function (e) {
  e.preventDefault()
  if (window.history.length > 1 && document.referrer !== '') {
    window.history.back()
  } else {
    window.location.href = this.href
  }
})
